export default {"src":"/_next/static/media/phone.d60c9ba0.svg","height":37,"width":37,"blurWidth":0,"blurHeight":0};